import { FunctionsHelper } from '../../utils/FunctionsHelper';
import { REMOVE, UPDATE } from '../actions/intlActions/ActionTypes';
import { Action } from '../models/Action';

export interface IntlStore {
  lang: string;
  dateFormat: string;
}

const initialLang = localStorage.getItem('userLang') || 'es';
const defaultStore: IntlStore = {
  lang: initialLang,
  dateFormat: FunctionsHelper.getDateFormatByLang(initialLang),
};

export default function IntlReducer(
  state: IntlStore = defaultStore,
  action: Action
) {
  switch (action.type) {
    case UPDATE:
      return {
        ...state,
        ...action.payload,
        dateFormat: FunctionsHelper.getDateFormatByLang(
          action.payload?.lang ?? state.lang
        ),
      };
    case REMOVE:
      return { ...defaultStore };
    default:
      return state;
  }
}
